const REGION_DELETE_DIALOG = 'REGION_DELETE_DIALOG';
const REGION_CREATE_DIALOG = 'REGION_CREATE_DIALOG';

export default {
    REGION_DELETE_DIALOG,
    REGION_CREATE_DIALOG
};
